import { extend } from 'flarum/common/extend';
/**
 * ianm/twofactor: its setup modals focus the code field by its name
 * ("token"), but the field has none, so focus stayed on the close button,
 * ringed. Named, the modal focuses it, ready for the code. The look is in
 * two-factor.less.
 */
export default function twoFactor() {
  extend('ext:ianm/twofactor/forum/components/TwoFactorCodeInput', 'view', vnode => {
    const input = vnode;
    if (input?.attrs) input.attrs.name = 'token';
  });
}